import { useEffect, useRef, useState } from "react";
import { getBackendApiUrl } from "../../../../utils/BackendUrl";

export default function useWebSocketNotifications(token) {
    const [messages, setMessages] = useState([]);
    const ws = useRef(null);

    const apiBase = getBackendApiUrl();
    const wsBase = apiBase.replace(/^http/, "ws");

    useEffect(() => {
        if (!token) return;

        const socket = new WebSocket(
            `${wsBase}/ws/admin/notifications/?token=${token}`
        );
        ws.current = socket;

        socket.onopen = () => {
            socket.onmessage = (event) => {
                console.log(event, "event")
                try {
                    const data = JSON.parse(event.data);
                    setMessages((prev) => [data, ...prev]);
                } catch (err) {
                    console.error("Error parsing message:", err);
                }
            };
        };

        socket.onclose = () => {
            console.log("WebSocket closed. Reconnecting...");
            setTimeout(() => {
                ws.current = null;
            }, 3000);
        };

        return () => {
            socket.close();
        };
    }, [token]);

    return messages;
}
